import { BadRequestError } from '@cian/valuation-utils-component';
import { omit } from 'ramda';

import { TThunkAction } from '../../types/redux';
import {
  fetchCreateMessageFromEstimation,
  TCreateMessageFromEstimationResponse
} from '../../repositories/price-estimator/v1/create-message-from-estimation';
import { setDemandRequestError, setDemandRequestSent, setDemandRequestSuccess } from './actions';
import { selectEstimationId } from '../../selectors/page';

export const sendDemandRequest = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();
    const {
      dataPayment: {
        demandRequest: { phone, dealType: dealTypeEx },
      },
    } = state;
    const parameters = {
      phone,
      dealTypeEx,
      estimationId: selectEstimationId(state) as number,
    };

    dispatch(setDemandRequestSent());

    try {
      const res = (await fetchCreateMessageFromEstimation({
        httpApi,
        parameters,
      })) as TCreateMessageFromEstimationResponse;

      if (res.statusCode === 200) {
        dispatch(setDemandRequestSuccess());

        return;
      }

      throw new BadRequestError({
        domain: 'sendDemandRequest.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    } catch (error) {
      dispatch(setDemandRequestError());

      logger.error(error, {
        message: 'Unable to send demand request',
        ...omit(['phone'], parameters),
      });
    }
  };
};
